<template lang="pug">
  el-collapse.nbhd(:value="defaultOpen" @change="collChange")
    el-collapse-item(:name="nbhdData.nbhdName + '|' + nbhdData.nbhdGuid")
      template(slot="title")
        .nbhd_header
          span.resi_name {{nbhdData.nbhdName}}
          div
            span 成功率：
              span.amount {{((nbhdData.activePlayCount*100)/(normalPlayCount*nbhdData.deviceCount)).toFixed(2)}}%
            span 合计金额：
              span.amount.black_col {{fee(nbhdData.amount)}}.{{fee(nbhdData.amount,1)}}元
            span 总屏幕数：
              span.screens {{nbhdData.deviceCount}}个
      //- 楼幢list
      put-detail-build(v-for="(bItem, i) in nbhdData.detailBuild" :bdata="bItem" :key="bItem.build + '__' + i" :normalPlayCount="normalPlayCount")
</template>

<script>
import PutDetailBuild from './PutDetailBuild'
import { getOrderNbhdPlayInfo } from '@/utils/api'

export default {
  name: 'MonitDetail',
  components: { PutDetailBuild },
  props: {
    nbhdData: {
      type: Object,
      default () {
        return {
          activePlayCount: 0,
          deviceCount: 0,
          nbhdGuid: 0,
          amount: 0,
          nbhdName: ""
        }
      }
    },
    defaultOpen: {
      type: Array,
      default () {
        return []
      }
    },
    buildParam: {
      type: Object,
      default () {
        return {}
      }
    },
    normalPlayCount: {
      type: Number,
      default: 0
    },
    chooseDate: '',
    screenType: ''
  },
  data () {
    return {}
  },
  computed: {
    fee () {
      return (money, type) => {
        if (!money) return type ? '00' : 0
        let isMinus = money < 0
        if (isMinus) money = 0 - money
        if (!type) {
          let arr = (Math.floor(money) + '').split('').reverse()
          let a = []
          arr.forEach((el, i) => {
            a.push(el)
            if ((i + 1) % 3 == 0) a.push(',')
          })
          let str = a.reverse().join('')
          let data = str.charAt(0) == ',' ? str.slice(1) : str
          return isMinus ? '-' + data : data
        } else {
          let sp = ((money - 0).toFixed(2) + '').split('.')
          if (sp.length <= 1) return '00'
          return (sp[1] + '').length == 1 ? sp[1] + '0' : sp[1]
        }
      }
    }
  },
  methods: {
    async collChange (opens) {
      if (opens.length > 0) { // 展开的项集合
        if (this.nbhdData.detailBuild && this.nbhdData.detailBuild.length > 0) return
        let res = await getOrderNbhdPlayInfo({
          nbhdGuid: this.nbhdData.nbhdGuid,
          orderGuid: this.buildParam.guid,
          targetDate: this.chooseDate,
          screenType: this.screenType == '0'/*梯内*/ ? 1 : this.screenType == '1'/*梯外*/ ? 2 : 0  // 0-全部，1-仅梯内，2-仅梯外
        })
        if (res.code === 0) {
          this.$set(this.nbhdData, 'detailBuild', res.data)
        } else if (res.code === 900501) {
          this.messageTip(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-icon-arrow-right
  transform: rotate(90deg)
::v-deep .el-collapse-item__header > .is-active
  transform: rotate(270deg)
.nbhd_header
  width: 100%
  color: #999
  display: flex
  justify-content: space-between
  align-items: center
  padding-right: 20px
  .resi_name
    color: #282729
    font-size: 16px
    max-width: 280px
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .amount
    color: #FF3973
    margin-right: 20px
    padding-right: 20px
    position: relative
    &::after
      content: ''
      position: absolute
      background: #D4D4D4
      right: 0
      width: 1px
      height: 14px
      top: 3px
  .black_col
    color: #282729
  .screens
    color: #282729
</style>
